import { Tooltip } from "@mui/material";
import { dataFormat2 } from "../../../functions/dataFormat";

const WodaOdczytyRazemSzczegolyEdytujOpub = props => {

    const { edytowanyZakres, setEdytowanyZakres } = props;

    const handleOpubl = e => setEdytowanyZakres( prevState => ({...prevState, opublikowany: e.target.value}) );
    const handleMsc = e => setEdytowanyZakres( prevState => ({...prevState, miesiac: e.target.value}));
    
    return (
        <div className="row">
            <div className="inline">
                <label htmlFor="opubl">
                    <b>Czy opublikowany:</b>
                </label>
                <select 
                    id="opubl"
                    value={edytowanyZakres?.opublikowany}
                    onChange={handleOpubl}
                >
                    <option value={1}>
                        Tak
                    </option>
                    <option value={0}>
                        Nie
                    </option>
                </select>
                <Tooltip
                    title="Ważny jest miesiąc i rok, dzień obojętnie który."
                    placement='top'
                >
                    <input 
                        type="date"    
                        id="msc"
                        value={dataFormat2(edytowanyZakres?.miesiac)}
                        onChange={handleMsc}
                    />
                </Tooltip>
            </div>
        </div>
    )
}

export default WodaOdczytyRazemSzczegolyEdytujOpub;